/**
 * Utilitaires de gestion des zones de déplacement
 *
 * Classement : 1A < 1B < 2 < 3 < 4 < 5 < 6 < 7 < GD
 * Utilisé pour déterminer la zone dominante quand un employé
 * travaille sur plusieurs projets le même jour.
 */

/** Retourne le rang numérique d'une zone (plus élevé = plus éloigné) */
export const getZoneRank = (z: string | number | null | undefined): number => {
  if (!z) return 0;
  const s = z.toString().toUpperCase();
  if (s === '1A') return 1;
  if (s === '1B') return 2;
  if (s === '2') return 3;
  if (s === '3') return 4;
  if (s === '4') return 5;
  if (s === '5') return 6;
  if (s === '6') return 7;
  if (s === '7') return 8;
  if (s === 'GD') return 9;

  // Fallback numérique (legacy)
  const num = parseFloat(s);
  return isNaN(num) ? 0 : num + 2;
};
